import { useState } from "react";
import { EditSupplierDialog } from "../dialogs/EditSupplierDialog";
import { SupplierHistoryDialog } from "../dialogs/SupplierHistoryDialog";
import { UploadDocumentDialog } from "../dialogs/UploadDocumentDialog";
import { DocumentsDialog } from "../dialogs/DocumentsDialog";
import { Supplier } from "../types";
import { EditButton } from "./buttons/EditButton";
import { HistoryButton } from "./buttons/HistoryButton";
import { OrderButton } from "./buttons/OrderButton";
import { UploadButton } from "./buttons/UploadButton";
import { DeleteButton } from "./buttons/DeleteButton";
import { DocumentsButton } from "./buttons/DocumentsButton";

interface SupplierActionsProps {
  supplier: Supplier;
  onAddOrder: (supplierId: string) => void;
  onDelete: () => void;
  onUpdate: () => void;
}

export const SupplierActions = ({
  supplier,
  onAddOrder,
  onDelete,
  onUpdate,
}: SupplierActionsProps) => {
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [isHistoryDialogOpen, setIsHistoryDialogOpen] = useState(false);
  const [isUploadDialogOpen, setIsUploadDialogOpen] = useState(false);
  const [isDocumentsDialogOpen, setIsDocumentsDialogOpen] = useState(false);

  return (
    <>
      <div className="flex gap-2">
        <EditButton onClick={() => setIsEditDialogOpen(true)} />
        <HistoryButton onClick={() => setIsHistoryDialogOpen(true)} />
        <OrderButton onClick={() => onAddOrder(supplier.id)} />
        <UploadButton onClick={() => setIsUploadDialogOpen(true)} />
        <DocumentsButton onClick={() => setIsDocumentsDialogOpen(true)} />
        <DeleteButton onClick={onDelete} />
      </div>

      <EditSupplierDialog
        open={isEditDialogOpen}
        onOpenChange={setIsEditDialogOpen}
        onSuccess={onUpdate}
        supplier={supplier}
      />

      <SupplierHistoryDialog
        open={isHistoryDialogOpen}
        onOpenChange={setIsHistoryDialogOpen}
        supplier={supplier}
      />

      <UploadDocumentDialog
        open={isUploadDialogOpen}
        onOpenChange={setIsUploadDialogOpen}
        supplierId={supplier.id}
        onSuccess={onUpdate}
      />

      <DocumentsDialog
        open={isDocumentsDialogOpen}
        onOpenChange={setIsDocumentsDialogOpen}
        supplierId={supplier.id}
        supplierName={supplier.name}
      />
    </>
  );
};